import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import './Plans.css';
import tickCircleIcon from '../assets/images/tickCircleIcon.svg';
import { paymentService } from '../Network/services/paymentService';
import { planService } from '../Network/services/planService';

const Plans = ({ dispatch }) => {
  const [activeTab, setActiveTab] = useState('buy');
  const [purchasedFilter, setPurchasedFilter] = useState('all');
  const [loading, setLoading] = useState(false);
  const [availablePlans, setAvailablePlans] = useState([]);
  const [purchasedPlans, setPurchasedPlans] = useState([]);
  const [user, setUser] = useState(null);
  const history = useHistory();


  useEffect(() => {
    fetchPlansData();
    try {
      const rawUser = window.localStorage.getItem("UserData");
      const userData = rawUser ? JSON.parse(rawUser) : null;
      setUser(userData);
    } catch (e) {
    }
  }, []);

  const fetchPlansData = async () => {
    setLoading(true);
    
    try {
      const payload = new FormData();
      const response = await planService.getPlansAndMyPlans(payload);
      
      if (response.status === 200) {
        const transformedPlans = response.data.plans
          .filter(plan => plan.status === "1") 
          .map(plan => ({
            id: plan.plan_id,
            name: plan.subscription_name,
            price: parseFloat(plan.price),
            currency: '₹',
            unit: 'job post',
            description: plan.description,
            features: plan.content,
            recommended: plan.is_recommended == "1",
            is_premium: plan.is_premium,
            gst_percentage: plan.gst_percentage
          }))
          .sort((a, b) => b.price - a.price); 
          const activePlans = response.data.subscribed_plans?.filter(plan => plan.status.toLowerCase() === "active");
        
        const transformedPurchasedPlans = activePlans.map(plan => {
          const planData = response.data.plans.find(p => p.plan_id === plan.plan_id);
          
          const mappedStatus = plan.job_id ? 'used' : 'unused';
          
          return {
            id: plan.user_plan_id,
            type:  planData.subscription_name ,
            status: mappedStatus,
            purchaseDate: plan.start_date ? new Date(plan.start_date).toLocaleDateString('en-GB', {
              day: '2-digit',
              month: 'short',
              year: 'numeric'
            }) : null,
            jobId: plan.job_id,
            is_premium: planData.is_premium || "0"
          };
        });
        
        setAvailablePlans(transformedPlans);
        setPurchasedPlans(transformedPurchasedPlans);
      } else {
        toast.error('Failed to fetch plans data');
      }
    } catch (err) {
      toast.error('Failed to fetch plans data');
    } finally {
      setLoading(false);
    }
  };


  const filteredPlans = purchasedPlans.filter(plan => {
    if (purchasedFilter === 'all') return true;
    if (purchasedFilter === 'used') return plan.status === 'used';
    if (purchasedFilter === 'unused') return plan.status === 'unused';
    return true;
  });

  const handleUsePlan = (plan) => {
    dispatch({ type: 'SELECT_PLAN', payload: plan });
    history.push('/postjob');
  };

  const handleViewJob = (jobId) => {
    history.push(`/job/${jobId}`);
  };

  const handleGetStarted = async (planId) => {
    if (user && (user.is_kyc_updated == "0")) {
      toast.error("Kindly verify your KYC in your profile to access the plans.", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }

    try {
      const payload = new FormData();
      payload.append('plan_id', planId); 
      
      const response = await paymentService.createPaymentOrder('create_payment_order', payload);
      
      if (response.status === '200' && response.data && response.data.cashfree_order) {
        const checkoutUrl = response.data.cashfree_order.payment_link;
        window.location.href = checkoutUrl;
      } else {
        toast.error('Failed to create payment order. Please try again.');
      }
    } catch (error) {
      toast.error('Payment initialization failed. Please try again.');
    }
  };


  return (
    <div className="plans-container">
      <div key={activeTab} className="animation-overlay"></div>
      <div className="content">
        <h1 className="title">Plans</h1>
        
        <div className="tab-container">
          <div 
            className={`tab ${activeTab === 'buy' ? 'active-tab' : ''}`}
            onClick={() => setActiveTab('buy')}
          >
            Buy New Plan
          </div>
          <div 
            className={`tab ${activeTab === 'purchased' ? 'active-tab' : ''}`}
            onClick={() => setActiveTab('purchased')}
          >
            Purchased Plans
          </div>
        </div>

        {activeTab === 'buy' && (
          <div className="buy-plans-container">
            {loading ? (
              <div className="loading-message">
                <div className="plans-spinner"></div>
                <div>Loading plans...</div>
              </div>
            ) : availablePlans.length > 0 ? (
              availablePlans.map((plan) => (
                <div key={plan.id} className="buy-plan-card">
                  {plan.recommended && (
                    <div className="recommended-badge">RECOMMENDED</div>
                  )}
                  <div className={`buy-plan-name ${plan.is_premium === "0" || plan.is_premium === 0 ? 'lite-plan' : 'premium-plan'}`}>{plan.name}</div>
                  <div className="price-container">
                    <div className="price">{plan.currency} {plan.price}/</div>
                    <div className="price-unit"> {plan.unit}</div>
                  </div>
                  <div className='price-description-container'>
                    <p>{plan.gst_percentage}% GST will be added during payment.</p>
                  </div>
                  <button 
                    className={`get-started-button ${plan.recommended ? 'get-started-button-premium' : 'get-started-button-premium'}`}
                    onClick={() => handleGetStarted(plan.id)}
                  >
                    Get Started
                  </button>
                  <ul className="features-list">
                  <div className="buy-plan-description">
                    {plan.description}
                  </div>
                    {plan.features.map((feature, index) => (
                      <li key={index} className="feature-item">
                        <img src={tickCircleIcon} alt="check" className="check-icon" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              ))
            ) : (
              <div className="no-plans-message">No plans available</div>
            )}
          </div>
        )}

        {activeTab === 'purchased' && (
          <>
            <div className="sub-tab-container">
              <div 
                className={`sub-tab ${purchasedFilter === 'all' ? 'active-sub-tab' : ''}`}
                onClick={() => setPurchasedFilter('all')}
              >
                All
              </div>
              <div 
                className={`sub-tab ${purchasedFilter === 'used' ? 'active-sub-tab' : ''}`}
                onClick={() => setPurchasedFilter('used')}
              >
                Used Plans
              </div>
              <div 
                className={`sub-tab ${purchasedFilter === 'unused' ? 'active-sub-tab' : ''}`}
                onClick={() => setPurchasedFilter('unused')}
              >
                Unused Plans
              </div>
            </div>

            <div className="plans-grid">
              {loading ? (
                <div className="loading-message">
                  <div className="plans-spinner"></div>
                  <div>Loading purchased plans...</div>
                </div>
              ) : filteredPlans.length > 0 ? (
                filteredPlans.map((plan) => (
                  <div key={plan.id} className="plan-card">
                    <div className="plan-id">PLAN ID: {plan.id}</div>
                    <div className={`plan-name ${plan.is_premium === "0" || plan.is_premium === 0 ? 'lite-plan' : 'premium-plan'}`}>{plan.type}</div>
                    
                    {plan.status === 'unused' ? (
                      <>
                        <div className="status-badge unused-badge">
                          Unused
                        </div>
                        <div className="plan-actions">
                          <div className="plan-info">
                          Purchased on {plan.purchaseDate}
                          </div>
                          <button 
                            className="action-button use-plan-button"
                            onClick={() => handleUsePlan(plan)}
                            disabled={loading}
                          >
                            Use Plan
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="status-badge used-badge">
                          Used
                        </div>
                        <div className="plan-actions">
                          <div className="plan-info">
                              Used for Job: {plan.jobId}
                          </div>
                          <a 
                            href="#"
                            className="view-job-link"
                            onClick={(e) => {
                              e.preventDefault();
                              handleViewJob(plan.jobId);
                            }}
                          >
                            View Job
                          </a>
                        </div>
                      </>
                    )}
                  </div>
                ))
              ) : (
                <div className="no-plans-message">No purchased plans found</div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(Plans);
